import { ChangeDetectionStrategy, Component, inject, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { SelectIndustryListComponent } from '@app/shared/components/select-industry-list/select-industry-list.component';
import { SelectMode } from '@app/shared/types/enums/select-mode.enum';
import { Industry } from '@app/shared/types/models/industry/industry.model';
import { SelectIndustryDialogData } from '@app/shared/types/models/project-industry/project-industry.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-select-industry-dialog',
  imports: [SelectIndustryListComponent, MatDialogModule, TranslatePipe, UiDialogComponent, UiButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './select-industry-dialog.component.html'
})
export class SelectIndustryDialogComponent implements OnInit {
  private readonly dialogRef: MatDialogRef<SelectIndustryDialogComponent> = inject(
    MatDialogRef<SelectIndustryDialogComponent>
  );

  protected readonly dialogData: SelectIndustryDialogData = inject(MAT_DIALOG_DATA);

  protected selectedIndustries: WritableSignal<Industry[]> = signal<Industry[]>([]);
  protected industries: Signal<Industry[]> = signal([]);
  protected selectMode: SelectMode = SelectMode.SINGLE;

  public ngOnInit(): void {
    this.industries = this.dialogData.industries;
    if (this.dialogData.selectMode) {
      this.selectMode = this.dialogData.selectMode;
    }
    const preSelectedIndustries = this.dialogData.selectedIndustries;
    if (preSelectedIndustries?.length > 0) {
      this.selectedIndustries.set(preSelectedIndustries);
    }
  }

  public save(): void {
    if (this.selectMode === SelectMode.SINGLE) {
      this.dialogRef.close(this.selectedIndustries()[0]);
    } else {
      this.dialogRef.close(this.selectedIndustries());
    }
  }
}
